module.exports = __webpack_public_path__ + "img/climate_change_adaptation.fa92a95.svg";